import {ApiError} from 'thermia-react-container';
import {RegistrationDTO} from "../types/registrationTypes";

export class RegistrationConflictError extends Error {
  readonly response: Response;
  readonly status: number;
  readonly isConflict: boolean;
  readonly isRegistrationCompleted: boolean;
  data: any = undefined;
  private _isRegistrationConflict: boolean = false;
  private _isDeviceConflict: boolean = false;

  constructor(response: Response, message?: string) {
    super(message || `Registration conflict error (status: ${response.status})`);
    this.status = response.status;
    this.response = response;
    this.isConflict = response.status === 409;
    this.isRegistrationCompleted = response.status === 400;
  }

  getData = async () => {
    if (!this.isConflict) {
      return null
    }
    if (this.data !== undefined) {
      return this.data;
    }
    this.data = null;
    const responseJson = await this.response.json();
    try {
      const data = JSON.parse(responseJson.detail);
      if (!!data['Registration']) {
        this.data = ApiErrorHelper.deepCamelCaseKeys(data['Registration']) as RegistrationDTO;
        this._isRegistrationConflict = true;
      }
      if (!!data['DeviceIds']) {
        this.data = data['DeviceIds'];
        this._isDeviceConflict = true;
      }
    } catch (error) {
      console.error('Failed to parse registration conflict error data', error);
      console.error('Response JSON:', responseJson);
    }
    return this.data;
  }

  isDeviceConflict = async () => {
    await this.getData();
    return this._isDeviceConflict;
  }

  isRegistrationConflict = async () => {
    await this.getData();
    return this._isRegistrationConflict;
  }

}

export class ApiErrorHelper {
  static isOnsiteVersionInvalid(e: any) {
    return e instanceof ApiError && e.status === 412;
  }

  static isNotFound(e: any): e is ApiError {
    return e instanceof ApiError && e.status === 404;
  }

  static upperCamelToCamel(str: string) {
    return str.charAt(0).toLowerCase() + str.slice(1);
  }

  static deepCamelCaseKeys(obj: any): any {
    if (Array.isArray(obj)) {
      return obj.map(ApiErrorHelper.deepCamelCaseKeys);
    } else if (obj !== null && typeof obj === 'object') {
      return Object.fromEntries(
      Object.entries(obj).map(([key, value]) => [
        ApiErrorHelper.upperCamelToCamel(key),
        ApiErrorHelper.deepCamelCaseKeys(value)
      ])
      );
    }
    return obj;
  }

}
